import { Box, keyframes, styled } from "@mui/material";

const SIZE = 44;

const circularRotateKeyframe = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;

const circularDashKeyframe = keyframes`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;

const CircularProgressRoot = styled("span")(({ theme }) => ({
  color: theme.palette.primary.main,
  display: "inline-block",
  animation: `${circularRotateKeyframe} 1.4s linear infinite`,
}));

const CircularProgressSVG = styled("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
})({
  display: "block", // Keeps the progress centered
});

const CircularProgressCircle = styled("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
})({
  stroke: "currentColor",
  // Some default value that looks fine while waiting for the animation to kick in.
  strokeDasharray: "80px, 200px",
  strokeDashoffset: 0, // Add the unit to fix a Edge 16 and below bug.
  animation: `${circularDashKeyframe} 1.4s ease-in-out infinite`,
});

const CircularProgressTrack = styled("circle", {
  name: "MuiCircularProgress",
  slot: "Track",
})({
  stroke: "currentColor",
});

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
const TroveCircularProgress = () => {
  const color = "primary",
    size = 40,
    thickness = 7;

  return (
    <CircularProgressRoot style={{ width: size, height: size, color: color }} role="progressbar">
      <CircularProgressSVG viewBox={`${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`}>
        <CircularProgressTrack
          cx={SIZE}
          cy={SIZE}
          r={(SIZE - thickness) / 2}
          fill="none"
          strokeWidth={1.5}
          aria-hidden="true"
        />
        <CircularProgressCircle
          color="primary"
          cx={SIZE}
          cy={SIZE}
          r={(SIZE - thickness) / 2}
          fill="none"
          strokeWidth={thickness}
        />
      </CircularProgressSVG>
    </CircularProgressRoot>
  );
};

export const PendingComponent = () => {
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <TroveCircularProgress />
    </Box>
  );
};
